import types from './notificationsTypes.js'

const mutations = {
  [types.ADD_BULK_NOTIFICATIONS](state, payload) {
    state.notifications = payload.notifications?.map(notification => {
      notification.alerted = true
      return notification
    })
  },

  [types.MARK_ALL_NOTIFICATIONS_AS_READ](state, payload) {
    state.notifications = []
    state.notifications = payload.notifications?.map(notification => {
      notification.alerted = true
      notification.read = true
      return notification
    })
  },

  [types.CLEAR_NOTIFICATIONS](state) {
    state.notifications = []
  },

  [types.ADD_NOTIFICATION](state, payload) {
    state.notifications.unshift(payload.notification)
  },

  [types.ADD_NOTIFICATION_TO_ALERTS](state, payload) {
    state.alertsNotifications.unshift(payload.notification)
  },

  [types.CLEAR_NOTIFICATIONS_FROM_ALERTS](state) {
    state.alertsNotifications = []
  },

  [types.REMOVE_NOTIFICATION_FROM_ALERTS](state, payload) {
    const notifications = state.alertsNotifications
    const ids = state.alertsNotifications?.map(notification => {
      return notification._id
    })

    const index = ids.indexOf(payload.notification._id)
    if (index > -1) {
      notifications.splice(index, 1)
    }

    state.alertsNotifications = notifications
  },

  [types.REPLACE_NOTIFICATION](state, payload) {
    const notificationToReplace = payload.notification

    const notifications = state.notifications
    const ids = state.notifications?.map(notification => {
      return notification._id
    })

    const index = ids.indexOf(notificationToReplace._id)
    if (index > -1) {
      const originalNotification = Object.assign({}, notifications[index])
      originalNotification.read = true
      originalNotification.alerted = true
      notifications.splice(index, 1, originalNotification)
    }

    state.notifications = notifications
  },

  [types.SET_LAST_NOTIFICATION_ID](state, payload) {
    const { lastNotificationId } = payload
    state.lastNotificationId = lastNotificationId
  },
}

export default mutations
